import { FC } from 'react';
import { PropagateLoader } from 'react-spinners';
import {
  Bar,
  BarChart,
  CartesianGrid,
  ResponsiveContainer,
  Tooltip,
  XAxis,
  YAxis,
} from 'recharts';
import { ScaleType } from 'recharts/types/util/types';
import theme from '../../../styles/themes/default';
import { Container } from './styles';

interface IProps {
  title: string;
  data: any;
  barColor: string;
  isLoading: boolean;
  isFetching: boolean;
  error: any;
  scale?: Function | ScaleType | undefined;
  legendSize: number;
  interval: number | 'preserveStart' | 'preserveEnd' | 'preserveStartEnd' | 'equidistantPreserveStart';
}

const SingleVerticalBarChart: FC<IProps> = ({
  title,
  data,
  barColor,
  isLoading,
  isFetching,
  error,
  scale,
  legendSize,
  interval
}) => {
  return (
    <Container>
      {(isLoading || isFetching) && <h3>Carregando...</h3>}
      {error! && <h3>Falha ao carregar dados.</h3>}

      {(!isLoading || !isFetching) && data && data?.length > 0 && (
        <h3>{title}</h3>
      )}

      {!isLoading && !isFetching && (!data || data?.length === 0) && (
        <h3>'Não encontramos dados para sua pesquisa.'</h3>
      )}
      <ResponsiveContainer
        width="100%"
        height="100%"
        key={Math.floor(Math.random() * 45)}
      >
        {!isLoading && !isFetching ? (
          <BarChart
            layout="vertical"
            width={500}
            height={400}
            data={data}
            margin={{
              top: 0,
              right: 28,
              bottom: 0,
              left: 0,
            }}
          >
            <CartesianGrid stroke={theme.colors.gray[200]} />
            <XAxis
              scale={scale}
              type="number"
              interval={interval}
              style={{ stroke: 'none' }}
            />
            <YAxis
              dataKey="legend"
              type="category"
              width={legendSize}
              style={{ stroke: 'none', fontSize: 16 }}
            />
            <Tooltip
              formatter={(value, name) => [value, 'Quantidade']}
              labelFormatter={(label, p: any) => [
                (p[0]?.payload?.name && p[0]?.payload?.name?.length) > 15
                  ? p[0]?.payload?.name?.slice(0, 15) + '...'
                  : p[0]?.payload?.name || label,
              ]}
            />
            <Bar dataKey="value" fill={barColor || '#82ca9d'} barSize={36} />
          </BarChart>
        ) : (
          <aside>
            <PropagateLoader size={20} />
          </aside>
        )}
      </ResponsiveContainer>
    </Container>
  );
};

export default SingleVerticalBarChart;
